import { DEBOUNCE_TIME, IPerfLog, ITraceLog, PERF_HOSTS } from "../common/const";
import { consoleWarn, debounce, post, postBatch } from "../common/utils";
import { v4 as uuidv4 } from "uuid";

/**
 * perf.ts perflog
 */
interface IConfig {
    env: "production" | "development";
    bizName: string;
}
export class AdFrontTrace {
    private host: string;
    private traceId: string;
    private perfQueue: Object[] = [];
    private config: IConfig;
    private sendPerfDebounce = () => {};

    constructor(config: IConfig) {
        if (!config?.bizName || !config?.env) {
            consoleWarn("bizName，env为必填信息");
        }
        if (!PERF_HOSTS[config.env]) {
            consoleWarn(`env必须为${Object.keys(PERF_HOSTS)}之一`);
        }

        this.config = config;
        this.host = PERF_HOSTS[config.env];
        this.traceId = uuidv4();

        this.sendPerfDebounce = debounce(() => {
            postBatch(`${this.host}/rest/perf`, this.perfQueue);
        }, DEBOUNCE_TIME);
    }

    /**
     * perf上报方法，为了规范化上报subtag尽量使用预置枚举类型，不能满足需求联系 @zhaizhe 添加
     * @param param
     */
    public perf(param: IPerfLog) {
        this.perfQueue.push({ namespace: this.config.bizName, ...param });
        this.sendPerfDebounce();
    }

    /**
     * trace上报方法，为了规范化上报尽量遵从ITraceLog定义，如果不能满足需求找sdk维护人添加字段 @zhaizhe
     * @param log
     */
    public trace(log: ITraceLog) {
        Object.assign(log, {
            timestamp: Date.now(),
            cookie: document.cookie,
            userAgent: navigator.userAgent,
            traceId: this.traceId,
        });
        const { message, ...restLog } = log;
        const param = {
            serviceName: this.config.bizName,
            level: "info",
            log: {
                tags: restLog,
                err: {},
                message,
            },
        };
        post(`${this.host}/rest/trace`, param);
    }

    /**
     * 获取全局唯一traceId，加入header中和后端日志做串联
     * @returns traceId
     */
    public getTraceId(): string {
        return this.traceId;
    }

    /**
     * 获取全局唯一traceId，加入header中和后端日志做串联
     * @returns traceId
     */
    public setTraceId(traceId: string): void {
        this.traceId = traceId;
    }
}
